import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createEnvelope, dsnFromString, forEachEnvelopeItem } from '@sentry/utils';
import { getEnvelopeEndpointWithUrlEncodedAuth } from '../api.js';

/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */
function eventFromEnvelope(env, types) {
  var event;
  forEachEnvelopeItem(env, function (item, type) {
    if (types.includes(type)) {
      event = Array.isArray(item) ? item[1] : undefined;
    }
    // bail out if we found an event
    return !!event;
  });
  return event;
}

/**
 * Creates a transport that overrides the release on all events.
 */
function makeOverrideReleaseTransport(createTransport, release) {
  return function (options) {
    var transport = createTransport(options);
    return _objectSpread(_objectSpread({}, transport), {}, {
      send: function () {
        var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(envelope) {
          var event;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                event = eventFromEnvelope(envelope, ['event', 'transaction', 'profile', 'replay_event']);
                if (event) {
                  event.release = release;
                }
                return _context.abrupt("return", transport.send(envelope));
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function send(_x) {
          return _send.apply(this, arguments);
        }
        return send;
      }()
    });
  };
}

/** Overrides the DSN in the envelope header  */
function overrideDsn(envelope, dsn) {
  return createEnvelope(dsn ? _objectSpread(_objectSpread({}, envelope[0]), {}, {
    dsn: dsn
  }) : envelope[0], envelope[1]);
}

/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */
function makeMultiplexedTransport(createTransport, matcher) {
  return function (options) {
    var fallbackTransport = createTransport(options);
    var otherTransports = new Map();
    function getTransport(dsn, release) {
      // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
      // use at the same time
      var key = release ? "".concat(dsn, ":").concat(release) : dsn;
      var transport = otherTransports.get(key);
      if (!transport) {
        var validatedDsn = dsnFromString(dsn);
        if (!validatedDsn) {
          return undefined;
        }
        var url = getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
        transport = release ? makeOverrideReleaseTransport(createTransport, release)(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        })) : createTransport(_objectSpread(_objectSpread({}, options), {}, {
          url: url
        }));
        otherTransports.set(key, transport);
      }
      return [dsn, transport];
    }
    function send(_x2) {
      return _send2.apply(this, arguments);
    }
    function _send2() {
      _send2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(envelope) {
        var getEvent, transports, results;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              getEvent = function _getEvent(types) {
                var eventTypes = types && types.length ? types : ['event'];
                return eventFromEnvelope(envelope, eventTypes);
              };
              transports = matcher({
                envelope: envelope,
                getEvent: getEvent
              }).map(function (result) {
                if (typeof result === 'string') {
                  return getTransport(result, undefined);
                } else {
                  return getTransport(result.dsn, result.release);
                }
              }).filter(function (t) {
                return !!t;
              }); // If we have no transports to send to, use the fallback transport
              if (transports.length === 0) {
                // Don't override the DSN in the header for the fallback transport. '' is falsy
                transports.push(['', fallbackTransport]);
              }
              _context2.next = 5;
              return Promise.all(transports.map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  dsn = _ref2[0],
                  transport = _ref2[1];
                return transport.send(overrideDsn(envelope, dsn));
              }));
            case 5:
              results = _context2.sent;
              return _context2.abrupt("return", results[0]);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _send2.apply(this, arguments);
    }
    function flush(_x3) {
      return _flush.apply(this, arguments);
    }
    function _flush() {
      _flush = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(timeout) {
        var promises, _iterator, _step, _step$value, transport;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fallbackTransport.flush(timeout);
            case 2:
              _context3.t0 = _context3.sent;
              promises = [_context3.t0];
              _iterator = _createForOfIteratorHelper(otherTransports);
              _context3.prev = 5;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context3.next = 16;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2), transport = _step$value[1];
              _context3.t1 = promises;
              _context3.next = 12;
              return transport.flush(timeout);
            case 12:
              _context3.t2 = _context3.sent;
              _context3.t1.push.call(_context3.t1, _context3.t2);
            case 14:
              _context3.next = 7;
              break;
            case 16:
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t3 = _context3["catch"](5);
              _iterator.e(_context3.t3);
            case 21:
              _context3.prev = 21;
              _iterator.f();
              return _context3.finish(21);
            case 24:
              return _context3.abrupt("return", promises.every(function (r) {
                return r;
              }));
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[5, 18, 21, 24]]);
      }));
      return _flush.apply(this, arguments);
    }
    return {
      send: send,
      flush: flush
    };
  };
}
export { eventFromEnvelope, makeMultiplexedTransport };